import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Button, Text } from '@chakra-ui/react';

const TIPS = [
  'aiContainer.blockedModalTip1',
  'aiContainer.blockedModalTip2',
  'aiContainer.blockedModalTip3',
  'aiContainer.blockedModalTip4',
];

// Shown in place of a student's message that was blocked by moderation, with a
// "See why" link that explains what happened and what to try next.
const BlockedMessage = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!isModalOpen) return undefined;
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsModalOpen(false);
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isModalOpen]);

  return (
    <>
      <div className="chat-blocked-message">
        {t('aiContainer.blockedMessage')}{' '}
        <button
          type="button"
          className="chat-blocked-message-link"
          onClick={() => setIsModalOpen(true)}
        >
          {t('aiContainer.blockedSeeWhy')}
        </button>
      </div>

      {isModalOpen &&
        // The "confirmation-modal" class keeps the floating chat from closing
        // when the user clicks inside the modal (see handleClickOutside).
        createPortal(
          <div
            className="confirmation-modal"
            onClick={(event) => {
              if (event.target === event.currentTarget) setIsModalOpen(false);
            }}
          >
            <div
              className="confirmation-modal-content blocked-message-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="blocked-message-modal-title"
            >
              <Text id="blocked-message-modal-title">
                <b>{t('aiContainer.blockedModalTitle')}</b>
              </Text>
              <Text mt={2}>{t('aiContainer.blockedModalExplanation')}</Text>
              <hr />
              <Text>
                <b>{t('aiContainer.blockedModalWhatCanIDo')}</b>
              </Text>
              <ul>
                {TIPS.map((tip) => (
                  <li key={tip}>{t(tip)}</li>
                ))}
              </ul>
              <div className="blocked-message-modal-actions">
                <Button
                  colorScheme="blue"
                  size="sm"
                  autoFocus
                  onClick={() => setIsModalOpen(false)}
                >
                  {t('general.close')}
                </Button>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </>
  );
};

export default BlockedMessage;
